import { Link } from '@tanstack/react-router';
import { BiCheckCircle } from 'react-icons/bi';
import { buttonVariants, Text, VStack } from 'ui_2';
import { Route as index_route } from '@routes/index';
import { Route as rewards_route } from '@routes/rewards';
import { Route as product_sku_route } from '@routes/$service/$productSKU/index';
import { usePurchaseStore } from './-purchaseStore';
import { useBreakpoints } from '@puzzlehq/frontend-utils';
import { useEffect } from 'react';
import { Confetti } from '@src/components/Confetti';

export const Confirmed = () => {
  const [_close] = usePurchaseStore((state) => [state.close]);

  const { title } = product_sku_route.useLoaderData();
  const { isSmall } = useBreakpoints();

  // useEffect(() => {
  //   Confetti(5_000);
  // }, []);

  return (
    <VStack className='h-full w-full gap-8'>
      <VStack className='flex-grow' />
      <VStack className='items-center gap-8 text-center'>
        <VStack className='items-center gap-2 text-center'>
          <BiCheckCircle size={68} className='text-green-400' />
          <Text font={isSmall ? 'bold-lg' : 'bold-md'} className='text-[18px]'>
            Purchase Submitted!
          </Text>
        </VStack>
        <Text font={isSmall ? 'regular-md' : 'regular-xs'} color='gray-500'>
          Your order is being processed.
          <br />
          Once your purchase and fulfillment are both settled, your{' '}
          {title ?? 'order'} will be sent to your wallet. You can view your
          Rewards in the Wallet Tab.
        </Text>
        {/* {createEventResponse?.eventId && (
          <Link
            onClick={() =>
              navigate({
                from: send_route.fullPath,
                to: event_detail_route.to,
                params: {
                  eventId: createEventResponse.eventId!,
                  address: selected?.address,
                },
                search: {
                  from: 'dashboard',
                },
              }).then(() => _close())
            }
          >
            View your transaction
          </Link>
        )} */}
      </VStack>
      <VStack className='flex-grow' />
      <VStack className='w-full gap-4'>
        <Link
          className={buttonVariants({ className: 'w-full' })}
          from={product_sku_route.fullPath}
          to={rewards_route.to}
          onClick={_close}
        >
          View Purchase
        </Link>
        <Link
          className={buttonVariants({ className: 'w-full', variant: 'gray' })}
          from={product_sku_route.fullPath}
          to={index_route.to}
          onClick={_close}
        >
          Go Home
        </Link>
      </VStack>
    </VStack>
  );
};
